'use strict';

import organization from './json/organization.json';
import machines from './json/machines.json';
import pages from './json/breadcrumbs/index.js';

export default class Microdata {
	constructor() {
        this.microdataType = document.querySelector('[data-microdata]').dataset.microdata;
        this.breadcrumbsMicrodata = document.querySelector('[data-breadcrumbs]')?.dataset?.breadcrumbs;
	    this.ldProductId = document.querySelector('[data-id]')?.dataset?.id;

        this.init();
	}

	init() {
        if(this.microdataType) {
            let data = '';

            switch(this.microdataType) {
                case 'organization':
                    data = organization;
                    break;
                case 'machines-list':
                    data = this.getMachinesListData();
                    break;
                case 'machine':
                    if (this.ldProductId) {
                        data = machines[this.ldProductId];
                    }

                    break;
                default:
                    break;
            }
            
            this.createJsonScript(data);
        }

        if (this.breadcrumbsMicrodata) {
            const data = this.getBreadcrumbsData(this.breadcrumbsMicrodata);

            this.createJsonScript(data);
        }
    }

    createJsonScript(data) {
        const scriptMicrodata = document.createElement('script');
        scriptMicrodata.type = 'application/ld+json';
        scriptMicrodata.innerHTML = JSON.stringify(data);
        document.body.appendChild(scriptMicrodata);
    }

    getBreadcrumbsData(page) {
        const mainPageData = {
            "@type": "ListItem",
            "position": 1,
            "item": {
                "@id": "https://calipri-nlt.ru/",
                "name": "Calipri-NLT"
            }
        };
        const commonData = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
        };

        return {
            ...commonData,
            itemListElement: [
                mainPageData,
                ...pages[page]
            ]
        };
    }

    getMachinesListData() {
        return {
            "@context": "https://schema.org/",
            "@type": "OfferCatalog",
            "name": "Колесотокарные станки от производителя Calipri-NLT",
            "image": "",
            "description": "Просмотрите наш каталог мобильных, стационарных, а также подрельсовых колесотокарных станков⚡ Мы предлагаем широкий выбор моделей собственного производства⭐",
            "itemListElement": Object.values(machines)
        };
    }
}
